// Static demo-mode fill-in data for Projects.component.jsx.
// Shapes must match exactly what this view's own rendering expects — see
// ProjectComponent's `teams.projects` Accordion loop (each project is
// `{ id, data: { project_name, taskList: [taskId], deleted } }`, read via
// `res.data.project_name` / `res.data.taskList` / `res.data.deleted`) and its
// `list` state (built by `getTasksNames()` from a Firestore per-task lookup,
// consumed as `list.find(a => a.id === taskId)?.title` — a flat array of
// `{ id, title }`).
//
// Task ids/titles/project assignments below match ProdaffTasksTab.demoData.js
// exactly (same underlying task records, viewed from a different page) —
// keep the two in sync if either changes.

export const DEMO_PROJECTS = [
  {
    id: 'demo-project-website-redesign',
    data: {
      project_name: 'Website Redesign',
      taskList: ['demo-task-1', 'demo-task-2', 'demo-task-3'],
      deleted: false,
    },
  },
  {
    id: 'demo-project-mobile-app',
    data: {
      project_name: 'Mobile App',
      taskList: ['demo-task-4', 'demo-task-5', 'demo-task-6'],
      deleted: false,
    },
  },
  {
    id: 'demo-project-internal-tools',
    data: {
      project_name: 'Internal Tools',
      taskList: ['demo-task-7', 'demo-task-8', 'demo-task-9'],
      deleted: false,
    },
  },
  {
    id: 'demo-project-marketing-site',
    data: {
      project_name: 'Marketing Website',
      taskList: ['demo-task-10', 'demo-task-11', 'demo-task-12'],
      deleted: false,
    },
  },
  {
    id: 'demo-project-client-portal',
    data: {
      project_name: 'Client Portal',
      taskList: [],
      deleted: false,
    },
  },
];

// Consumed as a flat id -> title lookup (mirrors the shape `getTasksNames()`
// builds from per-task Firestore docs). Titles line up with the task ids
// referenced in each project's `taskList` above, and with
// ProdaffTasksTab.demoData.js's DEMO_TASKS.
export const DEMO_TASK_TITLES = [
  { id: 'demo-task-1', title: 'Homepage layout' },
  { id: 'demo-task-2', title: 'Client feedback review' },
  { id: 'demo-task-3', title: 'Responsive QA pass' },
  { id: 'demo-task-4', title: 'API integration' },
  { id: 'demo-task-5', title: 'Bug fixes' },
  { id: 'demo-task-6', title: 'Push notification setup' },
  { id: 'demo-task-7', title: 'Dashboard analytics' },
  { id: 'demo-task-8', title: 'Code review' },
  { id: 'demo-task-9', title: 'CI pipeline cleanup' },
  { id: 'demo-task-10', title: 'Landing page copy' },
  { id: 'demo-task-11', title: 'SEO audit' },
  { id: 'demo-task-12', title: 'Blog redesign' },
];
